import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

const LocationComponentSkeleton = ({}) => {
  const styles = useStyles();

  return (
    <Box className={styles.wrapperLocationComponent}>
      <Skeleton variant="rect" width={"100%"} height={"100%"} style={{borderRadius:'12px'}} />
    </Box>
  );
};

export default LocationComponentSkeleton;
